var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.224 13.9702H0V0H7.224C11.088 0 14.224 3.12933 14.224 6.9851C14.224 10.8409 11.088 13.9702 7.224 13.9702Z",
    fill: "#060C18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.7835V29.9921H0V22.7835C0 18.9277 3.136 15.8064 7 15.8064C10.864 15.8064 14 18.9277 14 22.7835Z",
    fill: "#060C18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.776 16.0298H30V30H22.776C18.912 30 15.776 26.8707 15.776 23.0149C15.776 19.1591 18.912 16.0298 22.776 16.0298Z",
    fill: "#060C18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.20863V0H30V7.20863C30 11.0644 26.864 14.1937 23 14.1937C19.136 14.1937 16 11.0644 16 7.20863Z",
    fill: "#060C18"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.d666ffccedc5e82f0445d4cd4ee6b36f.svg";
export { ForwardRef as ReactComponent };